import React from 'react'
import UaeBloreHead from '../../UaeAttestation/UaeBlore/UaeBloreHead'
import "./../../UaeAttestation/UaeBlore/UaeBlore.css"
import QatarBloreMain from './QatarBloreMain'
const QatarBlore = () => {
  return (
    <div className="uaeBloreContainer">
    <UaeBloreHead head="Qatar Attestation in Bangalore" />
    <QatarBloreMain/>
  </div>
  )
}

export default QatarBlore
